"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indicatorSchema = void 0;
var claim_domain_1 = require("@hobt/claim-domain");
var constants_1 = require("@hobt/constants");
var utils_1 = require("@hobt/utils");
var Joi = require('joi').extend(require('@joi/date'));
exports.indicatorSchema = Joi.object({
    claimProcessingUnitType: Joi.number()
        .integer()
        .min(claim_domain_1.ClaimProcessUnitTypeEnum.Single)
        .max(claim_domain_1.ClaimProcessUnitTypeEnum.Multi)
        .options({ convert: false }),
    claimReceivedDate: Joi.date()
        .less(utils_1.getCurrentDate())
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'Claim Received Date'),
    }),
    eddFemsi: Joi.boolean(),
    editsAndAllowances: Joi.boolean(),
    enhancedAcpp: Joi.boolean(),
    gvsPvii: Joi.boolean().optional(),
    notepadComment: Joi.boolean(),
    paymentCount: Joi.number()
        .integer()
        .min(0)
        .max(400)
        .options({ convert: false }),
    rffi: Joi.boolean(),
    underwritingInformationReceivedDate: Joi.date()
        .less(utils_1.getCurrentDate())
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'Underwriting Information Received Date'),
    })
        .optional()
        .when('underwritingReview', {
        is: true,
        then: Joi.required(),
    }),
    underwritingInformationRequestedDate: Joi.date()
        .less(utils_1.getCurrentDate())
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'Underwriting Information Requested Date'),
    })
        .optional()
        .when('underwritingReview', {
        is: true,
        then: Joi.required(),
    }),
    underwritingReview: Joi.boolean(),
    underwritingReviewEndDate: Joi.date()
        .less(utils_1.getCurrentDate())
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'Underwriting Review End Date'),
    })
        .optional()
        .when('underwritingReview', {
        is: true,
        then: Joi.required(),
    }),
    underwritingReviewStartDate: Joi.date()
        .less(utils_1.getCurrentDate())
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'Underwriting Review Start Date'),
    })
        .optional()
        .when('underwritingReview', {
        is: true,
        then: Joi.required(),
    }),
});
exports.default = { indicatorSchema: exports.indicatorSchema };
